import { render } from "./StepNavigation.vue?vue&type=template&id=040dc340&scoped=true"
import script from "./StepNavigation.vue?vue&type=script&lang=js"
export * from "./StepNavigation.vue?vue&type=script&lang=js"

import "./StepNavigation.vue?vue&type=style&index=0&id=040dc340&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-040dc340"]])

export default __exports__